/**
 * 休假 - 我的申请列表
 */


import React, { Component } from 'react';
import { Container } from 'flux/utils';
import dispatcher, { dispatch } from '../../dispatcher/Dispatcher';
import ajax, { ajaxDispatch } from '.././../common/utils/ajax';
import { getItem as getLang } from '../../common/lang';

import CSSTransitionGroup from 'react/lib/ReactCSSTransitionGroup';

import Button from '../../components/Button/Button.jsx';
import Form from '../../components/Form/Form.jsx';
import Header from '../../components/Header/Header.jsx';
import Loader from '../../components/Loader/Loader.jsx';
import Tab from '../../components/Tab/Tab.jsx';
import PageOpener from '../../components/PageOpener/PageOpener.jsx';
import PullLoader from '../../components/PullLoader/PullLoader.jsx';
import RecordList from '../../components/RecordList/RecordList.jsx';
import UserList from '../../components/UserList/UserList.jsx';

import LeaveStore from '../../stores/LeaveStore';
import LeaveDataUtils from '../../data-utils/LeaveDataUtils';


class LeaveList extends Component {
  static getStores() {
    return [LeaveStore];
  }

  static calculateState() {
    return LeaveStore.getState();
  }
  constructor(props) {
    super(props);
    this.checkEdit = this.checkEdit.bind(this);
    this.filter = this.filter.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.openApply = this.openApply.bind(this);
    this.applyResponse = this.applyResponse.bind(this);
    this.save = this.save.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    const { defaultFilter, mgr } = this.props;

    if (mgr) {
      this._type = 'get-mgr-leave-history';
    } else {
      this._type = 'get-emp-leave-records';
    }

    this.getEmpLeaveRecords(defaultFilter);
    LeaveDataUtils.getFilter(JSON.parse(localStorage.getItem('companyCode')));
  }

  componentDidUpdate() {
    var filenameList = [];
    var inputList = document.getElementsByTagName('input');
    var files = [];
    let fileDefaultValueCount = 0;
    this.state.leaveForm.map((item) => {
      if (item.type == 'file' && item.defaultValue != null) {
        fileDefaultValueCount++;
      }
    });

    let formInput;
    if (inputList.length > 0) {
      for (let i = 0; i < inputList.length; i++) {
        var input = inputList[i];
        if (!formInput) {
          formInput = input.parentNode;
        }
        if (input != null && input.type == 'file') {
          //input.multiple = 'multiple';
          if (files.length == 0) {
            input.currentShow = 1;
          }
          //console.log(files.length+' '+fileDefaultValueCount);
          if (fileDefaultValueCount == 0) {
            if (files.length > 0)
              input.parentNode.style.display = 'none';
          } else {
            if (files.length >= fileDefaultValueCount) {
              input.parentNode.style.display = 'none';
            }
          }
          if (!document.getElementById('remove' + (files.length + 1))) {
            let del = document.createElement('a');
            del.className = 'affixs-remove';
            del.href = 'javascript:;';
            del.text = 'Remove';
            del.index = files.length + 1;
            del.id = 'remove' + del.index;
            del.onclick = (e) => {
              //Remove事件
              var affixs = document.getElementById('affixs');
              //console.log(affixs.value);
              if (affixs != undefined) {
                var value = affixs.value;
                if (value != '') {
                  affixs.value = '';
                  var list = value.split(',');
                  for (let i = 0; i < list.length; i++) {
                    if ((e.target.index - 1) == i) {
                      affixs.value += ' ,';
                    } else {
                      affixs.value += list[i] + ',';
                    }
                  }
                }

                if (affixs.value != '') {
                  affixs.value = affixs.value.substr(0, affixs.value.length - 1);
                }
                del.parentNode.firstChild.innerText = '';
              }
              //console.log(affixs.value);
            };
            input.parentNode.appendChild(del);
          }
          if (files.length == 0)
            input.id = 'affix';
          else
            input.id = 'affix' + (files.length + 1);

          input.index = files.length + 1;
          files.push(input);

          input.onchange = (e) => {
            let filename = e.target.value.substr(e.target.value.lastIndexOf('\\') + 1);
            var exists = false;
            filenameList.map((item) => {
              console.log(item+' '+filename);
              if (item == filename) {
                exists = true;
              } 
            });

            if (exists) {
              alert('Duplicate file');
              e.target.value = '';
            } else {
              filenameList.push(filename);
              //console.log(filename);
              var affixs = document.getElementById('affixs');
              //console.log(affixs.value);
              if (affixs != undefined) {
                var value = affixs.value;
                if (value != '') {
                  affixs.value = '';
                  var list = value.split(',');
                  for (let i = 0; i < list.length; i++) {
                    if ((e.target.index - 1) == i) {
                      affixs.value += ' ,';
                    } else {
                      affixs.value += list[i] + ',';
                    }
                  }
                }

                if (affixs.value != '') {
                  affixs.value = affixs.value.substr(0, affixs.value.length - 1);
                }
              }
            }
          };
        }
        //console.log(input);
      }

      //添加隐藏域名affixs
      var affixs = '';
      this.state.leaveForm.map((item) => {
        if (item.type == 'file' && item.defaultValue != null) {
          affixs += item.defaultValue + ',';
        }
      });
      if (affixs != '') {
        affixs = affixs.substr(0, affixs.length - 1);
      }
      var inputAffixs = document.createElement('input');
      inputAffixs.type = 'hidden';
      inputAffixs.id = 'affixs';
      inputAffixs.name = 'affixs';
      inputAffixs.value = affixs;
      formInput.appendChild(inputAffixs);


      //console.log(formInput);
      //console.log(document.getElementsByTagName('form')[0]);
    }
  }


  checkEdit(item, e) {
    if (item.stateCode === 0) {
      e.preventDefault();

      this._editId = item.id;
      LeaveDataUtils.getLeaveEditRecord(item.id);
      this.openApply(e, true);
    }
  }

  save() {
    //添加附件值到hidden
    // var hidAffixs = document.createElement('input');
    // hidAffixs.type='hidden';
    // hidAffixs.id = 'affixs';
    // hidAffixs.name = 'affixs';
    // hidAffixs.ref = 'affixs';

    // if(hidAffixs.value!='' && hidAffixs.value != undefined){
    //     hidAffixs.value =hidAffixs.value.substr(0, hidAffixs.value.length - 1);
    // }
    // var domForm = document.getElementsByTagName('form')[0];
    // domForm.appendChild(hidAffixs);
    const form = this.refs.applyForm;

    if (!form.isValid() || window.leaveValidation && !window.leaveValidation()) return;

    const formData = new FormData(React.findDOMNode(form));
    this._submit = false;

    formData.append('submit', this._submit);

    if (this._editId) {
      formData.append('id', this._editId);
    }

    formData.append('verify', true);

    var affixs = '';
    this.state.leaveForm.map((item) => {
      if (item.type == 'file' && item.defaultValue != null) {
        affixs += item.defaultValue + ',';
      }
    });
    if (affixs != '') {
      affixs = affixs.substr(0, affixs.length - 1);
      formData.append('affixs', affixs);
      //console.log(affixs);
    }

    //LeaveDataUtils.submitForm();
    console.log(form);
    dispatch({
      type: 'form-submitting'
    });
    ajax.post(this.url, formData)
      .then((res) => {
        LeaveDataUtils.submitFormFail();
        this.applyResponse(res);
      })
      .catch(() => {
        LeaveDataUtils.submitFormFail();
      });
  }

  /**
   * 提交申请
   */
  submitForm() {
    // if (!this.refs.applyForm.isValid()) return;
    // if (window.leaveValidation) {
    //   if (!window.leaveValidation()) {
    //     return;
    //   }
    // }
    //console.log(window.leaveValidation());
    if (!this.refs.applyForm.isValid() || window.leaveValidation && !window.leaveValidation()) return;
    
    //console.log(document.getElementById('vct_app_vtyid').value);
    //console.log(document.getElementById('affix').value);
    // console.log(window.leaveValidation());
    // console.log(window.leaveValidation()=='false');
    // console.log(window.leaveValidation()==false);
    //    if(!window.leaveValidation()){ alert(1);return;}

    const formData = new FormData(React.findDOMNode(this.refs.applyForm));

    this._submit = true;

    formData.append('submit', this._submit);

    if (this._editId) {
      formData.append('id', this._editId);
    }

    formData.append('verify', true);

    var affixs = '';
    this.state.leaveForm.map((item) => {
      if (item.type == 'file' && item.defaultValue != null) {
        affixs += item.defaultValue + ',';
      }
    });
    if (affixs != '') {
      affixs = affixs.substr(0, affixs.length - 1);
      formData.append('affixs', affixs);
      //console.log(affixs);
    }

    LeaveDataUtils.submitForm();
    //console.log(this.url);

    // console.log('submitForm:');
    // console.log(formData);
    ajax.post(this.url, formData)
      .then((res) => {
        //console.log(res);
        LeaveDataUtils.submitFormFail();
        this.applyResponse(res);
      })
      .catch(() => {
        //console.log('error');
        LeaveDataUtils.submitFormFail();
      });
  }


  /**
   * Apply response
   * @param res
   */
  applyResponse(res) {

    if (res && res.error || res == undefined) {
      alert(res.error);
      LeaveDataUtils.submitFormFail();
      return false;
    } else if (res && res.confirm) {
      if (confirm(res.confirm)) {
        this._noVerify = true;

        const formData = new FormData(React.findDOMNode(this.refs.applyForm));

        formData.append('submit', this._submit);

        if (this._editId) {
          formData.append('id', this._editId);
        }

        formData.append('verify', false);

        LeaveDataUtils.submitForm();

        ajax.post(this.url, formData)
          .then((res) => {
            this.applyResponse(res);
            this.getEmpLeaveRecords({
              state: 'approving'
            });
          })
          .catch(() => {
            LeaveDataUtils.submitFormFail();
          });

        this.getEmpLeaveRecords({
          state: 'edit'
        });
        alert('success');
        location.reload();
        return;
      }
    }
    else {
      alert('success');
      location.reload();
    }

    // this._editId = null;

    // this.refs.apply.close();
    // this.refs.pullLoader.continueLoading();

    // this.getEmpLeaveRecords({
    //    state: 'edit'
    // });

  }

  /**
   * Open apply form
   * @param e
   * @param editMode
   */
  openApply(e, editMode) {
    this.editMode = (editMode === true);

    this.refs.apply.open(e);
    this.refs.pullLoader.stopLoading();

    if (editMode === true) {
      this.url = '/ess-edit-lv';
      return;
    } else {
      this.url = '/ess-insert-lv';
    }

    LeaveDataUtils.getLeaveForm();
  }


  /**
   * Select / unselect all
   */
  toggleSelectAll(e) {
    const selected = e.target.checked;

    [].slice.call(document.querySelectorAll('[type=checkbox]')).forEach(checkbox => {
      checkbox.checked = selected;
    });
  }


  render() {
    const { leaveRecords, status, leaveTypes, mgr, selectable, toggleSelect, filter, leaveForm, formIsSubmitting, formSubmitting, formPostback } = this.props;
    // if(leaveForm != ''){
    //   leaveForm.map((item)=>{
    //     if(item.type == 'file'){
    //       item.onChange = this.fileOnChange;
    //     }
    //   });
    // }
    if (filter) {
      filter.onClickItem = (state) => {
        this.getEmpLeaveRecords({
          state
        });
        if (state != 'edit') {
          dispatch({
            type: 'close-leave-record-selectable'
          });
        }
      };
    }

    // if(formSubmitting){
    //   location.reload();
    // }

    return (
      <div>
        <Header
          back
          title={getLang('MY_APPLY')}
          dropdown={filter}
          callback={::this.goback}
        />

        {/*<Filter items={filter} onFilter={this.filter}></Filter>*/}

        <PullLoader ref="pullLoader" status={status} onLoad={this.loadMore}>
          {
            mgr
              ? <div className="gap-t-lg">
                <UserList userList={leaveRecords} onSelectUser={this.selectUser} />
              </div>
              : <RecordList recordList={leaveRecords}
                url={'leave-record' + (mgr ? '-mgr' : '')}
                onClickItem={this.checkEdit}
                selectable={selectable && this.select}
                toggleSelect={this.toggleSelect} />
          }
        </PullLoader>

        {
          this.enableSubmit
            ? <Button icon='pencil' action onClick={this.toggleEnterMode} style={{ bottom: '8.5rem' }} />
            : null
        }

        <Button icon='plus' action onClick={this.openApply} />

        <PageOpener ref='apply'>
          <Loader status={status}>
            <Form className='side-gap pad-b' action='/leave-apply' ref='applyForm'
              controls={leaveForm} />
            <div className="row">
              <a href='javascript:;' className='btnAddFix' onClick={this.addFix}>+{getLang('FORM_ADD_FIX')}</a>
              <br />
              <br />
            </div>
            <div className="row">
              <div className="col-1-2">
                <Button type='button'
                  text={getLang('SAVE')}
                  disabled={formSubmitting}
                  onClick={this.save} />
              </div>
              <div className="col-1-2">
                <Button type='button'
                  text={getLang('SUBMIT')}
                  disabled={formSubmitting}
                  onClick={this.submitForm} />
              </div>
            </div>
          </Loader>
        </PageOpener>

        <CSSTransitionGroup component='div' transitionName='bottom-up'>
          {
            selectable ?
              <nav className='tab tab-bottom leave-mgr-bottom'>
                <label className='leave-mgr-select-all'>
                  <input type="checkbox" value="" onChange={this.toggleSelectAll} />
                </label>
                <div className='row'>
                  <div className='col-1-2'>
                    <Button text={getLang('SUBMIT')} disabled={!this.enableSubmit} onTouchTap={this.submit} />
                  </div>
                  <div className='col-1-2'>
                    <Button text={getLang('DROP')} hollow className='text-primary' onTouchTap={this.drop} />
                  </div>
                </div>
              </nav> : null
          }
        </CSSTransitionGroup>

        {!selectable && <Tab items={[
          {
            text: getLang('LEAVE_QUOTA'),
            name: 'my-leave/leave-quota',
            icon: 'calendar'
          },
          {
            text: getLang('MY_APPLY'),
            name: 'my-leave/leave-list',
            icon: 'plane'
          },
          {
            text: getLang('LEAVE_SUMMARY'),
            name: 'my-leave/leave-summary',
            icon: 'pie-chart'
          }
        ]} bottom />}
      </div>
    );
  }

  addFix() {
    var inputList = document.getElementsByTagName('input');
    var files = [];
    var currentShow = 1;
    if (inputList.length > 0) {
      for (let i = 0; i < inputList.length; i++) {
        var input = inputList[i];
        if (input != null && input.type == 'file') {
          input.multiple = 'multiple';
          if (files.length == 0) {
            input.currentShow += 1;
            currentShow = input.currentShow;
          }
          //console.log(currentShow);
          if (currentShow - 1 == files.length) {
            input.parentNode.style.display = 'block';
          }
          files.push(input);
        }
        //console.log(input);
      }
    }
  }

  fileOnChange(e) {
    //alert('change');
  }
  /**
   * Get employees' leave records (parameters)
   * @param params
   */
  getEmpLeaveRecords(params = {}) {
    params.page = 1;
    params.loadMore = false;
    params.state || (params.state = 'approving');

    this.enableSubmit = params.state === 'edit';

    dispatch({
      type: this._type,
      data: params
    });
  }

  goback() {
    dispatch({
      type: 'close-leave-record-selectable'
    });
    history.back();
  }
  /**
   * Load next page
   */
  loadMore() {
    dispatch({
      type: this._type,
      data: {
        loadMore: true
      }
    });
  }


  /**
   * Update filter
   * @param type
   * @param choice
   */
  filter(type, choice) {
    this.getEmpLeaveRecords({ type, choice });
  }

  /**
   * Test if an item is selectable
   * @param {Object} item
   */
  select(item) {
    return true;
  }

  toggleSelect(record) { }

  toggleEnterMode() {
    dispatch({
      type: 'toggle-leave-record-selectable'
    });
  }

  submit() {
    const inputs = [].slice.call(document.querySelectorAll('[type=checkbox]'))
      .filter(check => check.checked)
      .map(check => check.value);

    ajax.post('/ess-submit-lv', {
      idList: inputs.join()
    })
      .then(() => {
        location.reload();
      });
  }

  drop() {
    const inputs = [].slice.call(document.querySelectorAll('[type=checkbox]'))
      .filter(check => check.checked)
      .map(check => check.value);

    ajax.post('/ess-drop-lv', {
      idList: inputs.join()
    })
      .then(() => {
        location.reload();
      });
  }

  selectUser(id) {
    location.hash = 'my-leave/leave-list/' + id;
  }
}
export default Container.create(LeaveList);


// WEBPACK FOOTER //
// ./src/containers/Leave/LeaveList.jsx